"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialTextFieldGroupText = exports.MaterialTextFieldSortable = exports.MaterialTextField = void 0;
const callable_1 = require("client/components/ui/callable");
const Form_1 = require("material-ui/Form");
const Input_1 = require("material-ui/Input");
const styles_1 = require("material-ui/styles");
const React = require("react");
const react_1 = require("react");
require("./text-field.less");
const decorate = styles_1.withStyles(theme => ({
    formControl: {
        background: "#fff",
        border: "solid 1px rgba(0, 0, 0, 0.1)",
        borderRadius: "2px",
        fontSize: "14px",
        minHeight: 50,
        minWidth: 320,
        padding: "0 10px"
    },
    formControlDisabled: {
        color: "#aaa"
    },
    formControlError: {
        border: "1px solid #d81b60"
    },
    helperText: {
        color: "#d81b60",
        position: "absolute",
        top: 50
    },
    inputLabel: {
        transform: "translate(0, 10px) scale(1)"
    },
    inputFocused: {
        border: "1px solid rgba(24, 194, 115, 0.5)"
    },
    inputLabelShrink: {
        transform: "translate(0, 1px) scale(0.8)"
    },
    inputRoot: {
        minHeight: 50,
        left: 0,
        padding: "15px 0 0 10px",
        position: "absolute",
        top: -16
    },
    root: {}
}));
class MaterialTextFieldUnstyled extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleOnChange = (event) => {
            let { value } = event.target;
            if (value !== "") {
                if (this.props.type === "number" && this.props.numType === "integer") {
                    value = String(parseInt(value, 10));
                }
                if (this.props.numType === "decimal") {
                    value = value.replace(/[^0-9\.]/g, "");
                    value = String(parseFloat(value));
                }
                else if (this.props.numType === "price") {
                    value = value.replace(/[^0-9\.]/g, "");
                    let precision = value
                        .split(".")
                        .slice(1)
                        .join().length;
                    if (precision > 2) {
                        precision = 2;
                    }
                    if (precision > 0) {
                        value = String((Math.trunc(parseFloat(value) * 10000) / 10000).toFixed(precision));
                    }
                }
            }
            callable_1.callable(this.props.onChange)(event, value);
        };
        this.handleKeyDown = (event) => {
            if (event.key === " " && event.target.selectionStart === 0) {
                event.preventDefault();
            }
        };
    }
    render() {
        const { className = "", classes, disabled, error, label, leftItem, multiline = false, helperText, required, rightItem, value, missing, newPasswordField = false } = this.props;
        const hasIcon = leftItem ? "has-icon" : "";
        const hasError = error ? "material-text-field--error" : "";
        const isMissing = missing ? "material-text-field--missing" : "";
        return (React.createElement(Form_1.FormControl, { classes: {
                root: classes.formControl
            }, error: error, disabled: disabled, required: required, className: `material-text-field ${className} ${hasIcon} ${hasError} ${isMissing}` },
            leftItem && (React.createElement("div", { className: "material-text-field__icon" }, leftItem)),
            React.createElement(Input_1.InputLabel, { classes: {
                    root: classes.inputLabel,
                    shrink: classes.inputLabelShrink
                }, FormControlClasses: {
                    disabled: classes.formControlDisabled
                } }, label),
            React.createElement(Input_1.default, { autoFocus: this.props.autoFocus, onBlur: this.props.onBlur, onFocus: this.props.onFocus, classes: {
                    root: classes.inputRoot,
                    error: classes.formControlError,
                    focused: classes.inputFocused
                }, inputProps: this.props.inputProps, disableUnderline: true, fullWidth: true, multiline: multiline, onChange: this.handleOnChange, onKeyDown: this.handleKeyDown, type: this.props.type || "text", value: value, placeholder: this.props.placeholder, autoComplete: newPasswordField ? "new-password" : "on" }),
            rightItem ? (React.createElement("div", { className: "material-text-field__right-item" }, rightItem)) : null,
            React.createElement(Form_1.FormHelperText, { classes: {
                    root: classes.helperText
                } }, helperText)));
    }
}
class MaterialTextFieldUnstyledSortable extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleOnChange = (event) => {
            let { value } = event.target;
            if (value !== "") {
                if (this.props.type === "number" && this.props.numType === "integer") {
                    value = String(parseInt(value, 10));
                }
                if (this.props.numType === "decimal") {
                    value = value.replace(/[^0-9\.]/g, "");
                    value = String(parseFloat(value));
                }
                else if (this.props.numType === "price") {
                    value = value.replace(/[^0-9\.]/g, "");
                    let precision = value
                        .split(".")
                        .slice(1)
                        .join().length;
                    if (precision > 2) {
                        precision = 2;
                    }
                    if (precision > 0) {
                        value = String((Math.trunc(parseFloat(value) * 100) / 100).toFixed(precision));
                    }
                }
            }
            callable_1.callable(this.props.onChange)(event, value);
        };
        this.handleKeyDown = (event) => {
            if (this.props.type === "number" && this.props.numType === "integer") {
                if (event.key === ".") {
                    event.preventDefault();
                }
            }
            if (event.key === "Enter") {
                this.props.onBlur(); // #TK unfocused
            }
        };
    }
    render() {
        const { className = "", classes, disabled, error, label, leftItem, multiline = false, helperText, required, rightItem, value, missing } = this.props;
        const hasIcon = leftItem ? "has-icon" : "";
        const hasError = error ? "material-text-field--error" : "";
        const isMissing = missing ? "material-text-field--missing" : "";
        return (React.createElement(Form_1.FormControl, { classes: {
                root: classes.formControl
            }, error: error, disabled: disabled, required: required, className: `material-text-field ${className} ${hasIcon} ${hasError} ${isMissing}` },
            leftItem && (React.createElement("div", { className: "material-text-field__icon" }, leftItem)),
            React.createElement(Input_1.InputLabel, { classes: {
                    root: classes.inputLabel,
                    shrink: classes.inputLabelShrink
                }, FormControlClasses: {
                    disabled: classes.formControlDisabled
                } }, label),
            React.createElement(Input_1.default, { autoFocus: this.props.autoFocus, onBlur: this.props.onBlur, classes: {
                    root: classes.inputRoot,
                    error: classes.formControlError,
                    focused: classes.inputFocused
                }, disableUnderline: true, fullWidth: true, multiline: multiline, onChange: this.handleOnChange, onKeyDown: this.handleKeyDown, type: this.props.type || "text", value: value }),
            rightItem ? (React.createElement("div", { className: "material-text-field__right-item" }, rightItem)) : null,
            React.createElement(Form_1.FormHelperText, { classes: {
                    root: classes.helperText
                } }, helperText)));
    }
}
class MaterialTextFieldUnstyledGroupText extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleOnChange = (event) => {
            let { value } = event.target;
            if (value !== "") {
                if (this.props.type === "number" && this.props.numType === "integer") {
                    value = String(parseInt(value, 10));
                }
                if (this.props.numType === "decimal") {
                    value = value.replace(/[^0-9\.]/g, "");
                    value = String(parseFloat(value));
                }
                else if (this.props.numType === "price") {
                    value = value.replace(/[^0-9\.]/g, "");
                    let precision = value
                        .split(".")
                        .slice(1)
                        .join().length;
                    if (precision > 2) {
                        precision = 2;
                    }
                    if (precision > 0) {
                        value = String((Math.trunc(parseFloat(value) * 100) / 100).toFixed(precision));
                    }
                }
            }
            callable_1.callable(this.props.onChange)(event, value);
        };
        this.handleKeyDown = (event) => {
            if (this.props.type === "number" && this.props.numType === "integer") {
                if (event.key === ".") {
                    event.preventDefault();
                }
            }
            if (event.key === "Enter") {
                this.props.onBlur(); // #TK unfocused
                this.props.onAddGroup();
            }
        };
    }
    render() {
        const { className = "", classes, disabled, error, label, leftItem, multiline = false, helperText, required, rightItem, value, missing } = this.props;
        const hasIcon = leftItem ? "has-icon" : "";
        const hasError = error ? "material-text-field--error" : "";
        const isMissing = missing ? "material-text-field--missing" : "";
        return (React.createElement(Form_1.FormControl, { classes: {
                root: classes.formControl
            }, error: error, disabled: disabled, required: required, className: `material-text-field ${className} ${hasIcon} ${hasError} ${isMissing}` },
            leftItem && (React.createElement("div", { className: "material-text-field__icon" }, leftItem)),
            React.createElement(Input_1.InputLabel, { classes: {
                    root: classes.inputLabel,
                    shrink: classes.inputLabelShrink
                }, FormControlClasses: {
                    disabled: classes.formControlDisabled
                } }, label),
            React.createElement(Input_1.default, { autoFocus: this.props.autoFocus, onBlur: this.props.onBlur, classes: {
                    root: classes.inputRoot,
                    error: classes.formControlError,
                    focused: classes.inputFocused
                }, disableUnderline: true, fullWidth: true, multiline: multiline, onChange: this.handleOnChange, onKeyDown: this.handleKeyDown, type: this.props.type || "text", value: value }),
            rightItem ? (React.createElement("div", { className: "material-text-field__right-item" }, rightItem)) : null,
            React.createElement(Form_1.FormHelperText, { classes: {
                    root: classes.helperText
                } }, helperText)));
    }
}
exports.MaterialTextField = styles_1.withTheme()(decorate(MaterialTextFieldUnstyled));
exports.MaterialTextFieldSortable = styles_1.withTheme()(decorate(MaterialTextFieldUnstyledSortable));
exports.MaterialTextFieldGroupText = styles_1.withTheme()(decorate(MaterialTextFieldUnstyledGroupText));



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/text-field/text-field.tsx
// module id = 2442
// module chunks = 0 1